<style scoped>
</style>
<template>
    <div class="row">
        
        <div class="col-md-12" style="margin-bottom:10px;margin-top:5px">
            <div class="col-md-3">
                <label>Search Patient</label>
                <input class="form-control" v-model="searchText" />
            </div>
            <div class="col-md-2">

                <label>From Date</label>
                <SimpleDatePicker v-model="fromDate" />
            </div>
            <div class="col-md-2">
                <label>To Date</label>
                <SimpleDatePicker v-model="toDate"/>
            </div>
            <div class="col-md-5">
           
                <a class="btn btn-primary pull-right" @click="refreshCounter = refreshCounter+1" style="width:150px;margin-top:25px">
                    <i class="fa fa-refresh" />
                    <span>Refresh </span>
                </a>
            </div>
        </div>
        <div class="col-md-12">
            <div class="panel panel-default" style="margin-top:10px">
                <div class="panel-heading">
                    <h3 class="panel-title">Delivered Bags</h3>
                </div>
                <div class="panel-body">
                    <datatable ref="datatable" tablename="datatable-fmd-bag-list" :columns="columns" :source="getRecords" @selected="recordSelected" :datachanged="refreshCounter"></datatable>
                </div>
            </div>
            <!--<div class="table-responsive" style=" height:100%;">
                
            </div>-->
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import FmdDal from '../../../scripts/FmdDal'
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import Formatter from "../../corecontrols/formatters/Formatter"
    import moment from "moment"
    import SimpleDatePicker from "../../corecontrols/simpledatepicker/simpledatepicker.scp.html"
    export default {
        props: [],
        data: function () {
            var formatDate = Formatter.FormatDate;

            return {
                fromDate: new Date(),
                toDate: new Date(),
                searchText: "",
                searchTextTimer: null,
                prevSearchText: "",
                refreshCounter: 0,
                bags: [],
                loaded: false,
                loadingTask: {},
                FmdDal: null,
                columns: [
                    {
                        name: "", render: function (data, type, row, meta) {
                            return "#" + meta.row;
                        }
                    },
                    {
                        name: "FMD Status", data: "bagFMDStatus", render: function (data, type, row) {
                            var icon = "fa-refresh"
                            var style = "text-primary"
                            var text = ""
                            if (data == "10") {
                                icon = "fa-hourglass"
                                style = "text-warning"
                                text = "Pending"
                            }
                            if (data == "20") {
                                icon = "fa-check"
                                style = "text-success"
                                text = "Verified"
                            }
                            if (data == "30") {
                                icon = "fa-exclamation-triangle"
                                style = "text-danger"
                                text = "Failed"
                            }
                            return "<div class='" + style + "'><i class='fa " + icon + "'></i> <span>" + text + "</span> </div>";
                        }
                    },
                    {
                        name: "Bag Status", data: "bagStatus", render: function (data, type, row) {
                            var icon = "fa-refresh"
                            var style = "text-primary"
                            var text = ""
                            if (data == "0") {
                                icon = "fa-trash"
                                style = "text-danger"
                                text = "Deleted"
                            }
                            if (data == "10") {
                                icon = "fa-cog"
                                style = "text-warning"
                                text = "Working"
                            }
                            if (data == "20") {
                                icon = "fa-shopping-bag"
                                style = "text-success"
                                text = "Ready"
                            }
                            if (data == "30") {
                                icon = "fa-paper-plane"
                                style = "text-success"
                                text = "Delivered"
                            }
                            return "<div class='" + style + "'><i class='fa " + icon + "'></i> <span>"+ text + "</span> </div>";
                        }
                    },
                    {
                        name: "Name",
                        render: function (data, type, row) {
                            return row.firstName + ' ' + row.lastName;
                        }
                    },
                    {
                        name: "Aggregated Code",
                        data: "aggregatedCode"
                    },
                    {
                        name: "Created", data: "whenCreated", render: function (data, type, row) {
                            return Formatter.FormatDateTime(data)
                        }
                    },
                    {
                        name: "Dob", data: "dob", render: function (data, type, row) {
                            return formatDate(data)
                        }
                    },
                    {
                        name: "Items", data: "numberOfMeds", render: function (data, type, row) {
                            return data
                        }
                    }
                ]
            }
        },
        watch: {
            searchText() {
                if (this.searchTextTimer) {
                    clearTimeout(this.searchTextTimer)
                }
                let prevSearchText = this.searchText;
                setTimeout(() => {
                    if (this.searchText == prevSearchText ) {
                        this.refreshCounter++;
                    }
                }, 500);
            },

            fromDate() {
                this.refreshCounter++;
            },

            toDate() {
                this.refreshCounter++;
            }
        },
        mounted() {
            //alert("Mounting bag " + this.$root.CurrrentUnitId);
            var unitId = this.$root.CurrentUnitId;
            console.log("Mounting bag " , this.$root, this.$root.CurrentUnitId, unitId)
            this.FmdDal = new FmdDal(unitId, this.$root.UiSession);
            this.refreshCounter++;
            
        },
        methods: {
            FindFocus: function () {
                $(this.$el).find('div.dataTables_filter input').focus();
                //console.log($(this.$refs.datatable), search);
                //    search.focus();
            },
            getRecords: function (callback) {
                if(!this.FmdDal) {
                    callback({ data: [] });
                    return;
                }

                var fm = moment(this.fromDate);
                var tm = moment(this.toDate)
                if (!fm.isValid() && tm.isValid()) {
                        this.fromDate = this.toDate;
                }
                else if (!tm.isValid() && fm.isValid()) {
                    this.toDate = this.fromDate;
                }
                else if (!tm.isValid() && !fm.isValid()) {
                    this.fromDate = this.toDate = new Date()
                }
                else if (fm.isValid() && tm.isValid()) {
                    if (fm.diff(tm) > 0) {
                        var temp = this.toDate;
                        this.toDate = this.fromDate;
                        this.fromDate = temp;
                    }
                }
                

                console.log(this.searchText, this.fromDate, this.toDate)

                this.loadingTask = this.FmdDal.GetDeliveredBags(this.searchText, this.fromDate, this.toDate).then(data => {
                    console.log("Bags : ", data)
                    this.bags = data
                    return this.loaded = true;
                });

                this.loadingTask.then(() => callback({ data: this.filteredBags() }))
              
            },
            recordSelected(record) {
                console.log("Record Selected", record);
                this.$router.push({ path: 'bag/' + record.id });
            },
            filteredBags() {
                //return this.bags.filter(f => (f.status == "Working" && this.showWorking) || (f.status == "Ready" && this.showReady) || (f.status == "Delivered" && this.showDelivered));
                //return this.bags.filter(f => (f.bagStatus == 10 && this.showWorking) || (f.bagStatus == 20 && this.showReady) );
                return this.bags;
            }
        },
        components: {
            datatable,
            SimpleDatePicker
        }
    }
</script>


// WEBPACK FOOTER //
// Delivered.scp.html?2dde64f5